/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React from 'react';

function CellHolders(arrayHolderNames) {
    return arrayHolderNames?.map(item => <div key={item}>{item}</div>);
}

export default CellHolders;
